/**
 * --------------------------------------------------------------------------
 * NJ : Text.js
 * --------------------------------------------------------------------------
 */

import { Data, Manipulator, Testing } from 'nj-utils';
import AbstractFormControl from './AbstractFormControl';
import { coreConfig } from 'nj-components/core.config';


/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

// Required const for all components :
const DATA_KEY = `${coreConfig.KEY_PREFIX}.text`;

const SELECTOR = 'input:not([type=hidden]):not([type=checkbox]):not([type=radio]):not([type=file]):not([type=button]):not([type=submit]):not([type=reset])';

const DEFAULT_CONFIG = {
  njFormGroup: {
    required: false
  }
};

class Text extends AbstractFormControl {
  constructor(element, config) {
    super(Text, element, Manipulator.extend(true, DEFAULT_CONFIG, config));
    this.element = element;

    if (this.element) {
      Data.setData(element, DATA_KEY, this);
    }
  }

  dispose() {
    Data.removeData(this.element, DATA_KEY);
    this.element = null;
  }

  static init(options) {
    return super.init(this, options, SELECTOR);
  }

  static getInstance(element) {
    return Data.getData(element, DATA_KEY);
  }

  static matches(element) {
    return element.getAttribute('type') === 'text';
  }

  static rejectMatch(component, element) {
    Testing.assert(
      this.element,
      this.matches(element),
      `${component} component element ${Testing.describe(
        element
      )} is invalid for type='text'.`
    );
  }

  // Static
  static selector = SELECTOR;
}

export default Text;
